export const createQueryString = query =>
  Object.keys(query)
    .map(key => `${key}=${query[key] || ''}`)
    .join('&');

export const addQueryString = (url, query) => {
  const queryStringParams = createQueryString(query || {});
  return query ? `${url}?${queryStringParams}` : url;
};
